



import { defineComponent, onMounted } from "@vue/composition-api";
import { useDrawStore } from "@/store/draw";
import { DRAW_MODEL } from "@/constants/drawModel";
import { getSoilStatistics } from "@/api/land";
import {
  GraphicInfo,
  lngLatListToLatLngList,
  toNotClosedPath,
} from "@tuliu/base-map";
import { invokeUtilContainerHasSize } from "@/utils/container";

/**
 * 绘制地块
 */
export default defineComponent({
  setup() {
    const store = useDrawStore();

    const drawingNoDataToCreate = () => {
      store.drawModel = DRAW_MODEL.create;
    };

    const getUserLand = async () => {
      const [err, data] = await getSoilStatistics();
      if (!err && data !== undefined) {
        try {
          const list = data.coordinatesList.map((i) => JSON.parse(i));
          const ghList: GraphicInfo[] = [];

          list.forEach((_: string, index: number) => {
            ghList.push({
              id: index,
              isClosed: true,
              length: 0,
              area: 0,
              editorEnable: false,
              path: toNotClosedPath(lngLatListToLatLngList(list[index])),
            });
          });

          store.graphicInfoList = ghList;
        } catch (e) {
          drawingNoDataToCreate();
        }
      } else {
        drawingNoDataToCreate();
      }
    };

    onMounted(() => {
      invokeUtilContainerHasSize(() => {
        getUserLand();
      });
    });
  },
});
